import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import { DropdownToggle } from 'components/DropdownToggle';
import { hiddenExcludeReverseParams, includeReverseParams, visibleExcludeReverseParams } from 'constants/extraParams';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import { ReverseGroup } from '../ReverseGroup';

import css from './ReverseParams.module.css';

const ReverseParams = () => {
  const {
    app: { i18n },
    filter: {
      extraParams: { reverse },
    },
  } = useStore();
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const { include, exclude, allParams, excludedTotal, resetExcluded } = i18n.extraParams.reverse;
  const hasExcluded = reverse.excludedCount > 0;

  return (
    <div className={css.container}>
      <ReverseGroup className={css.includeList} mode="include" params={includeReverseParams} title={include} />

      <div className={css.group}>
        <ReverseGroup className={css.excludeList} mode="exclude" params={visibleExcludeReverseParams} title={exclude} />

        <div className={css.actions}>
          <DropdownToggle
            active={isDropdownActive}
            data-qa="reverse-all-params"
            dropdown={
              <ReverseGroup
                className={cn(css.dropdownList, 'glz-dropdown-list')}
                mode="exclude"
                params={hiddenExcludeReverseParams}
              />
            }
            onToggle={setIsDropdownActive}
          >
            <DropdownToggle.DefaultButton gray active={isDropdownActive}>
              {hasExcluded ? interpolate(excludedTotal, { count: reverse.excludedCount.toString() }) : allParams}
            </DropdownToggle.DefaultButton>
          </DropdownToggle>

          {hasExcluded && (
            <button
              className="glz-link glz-is-medium glz-is-gray"
              data-qa="reverse-reset"
              type="button"
              onClick={reverse.resetExcluded}
            >
              {resetExcluded}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const connected = observer(ReverseParams);

export { connected as ReverseParams };
